import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
	{
		path: "/admin/dashboard",
		title: " Dashboard",
		moduleName: "dashboard",
		icon: "fas fa-tachometer-alt",
		class: "",
		groupTitle: false,
		submenu: [],
		type: "0",
	},
	{
		path: "/admin/applications",
		title: "Applications",
		moduleName: "Application-table",
		icon: "fas fa-th",
		class: "",
		groupTitle: false,
		submenu: [],
		type: "0",
	},
	{
		path: "/admin/client-listing",
		title: "Clients",
		moduleName: "client listing",
		icon: "fas fa-id-card",
		class: "",
		groupTitle: false,
		submenu: [],
		type: "0",
	},

	{
		path: "",
		title: "Reports",
		moduleName: "email",
		icon: "fas fa-mail-bulk",
		class: "menu-toggle",
		groupTitle: false,
		type: "0",
		submenu: [
			{
				path: "/admin/sms/reports",
				title: "SMS",
				moduleName: "email",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "0",
			},
		],
	},

	{
		path: "/client/dashboard",
		title: "Dashboard",
		moduleName: "client",
		icon: "fas fa-tachometer-alt",
		class: "",
		groupTitle: false,
		submenu: [],
		type: "1",
	},
	{
		path: "/client/authorized-application",
		title: "Applications",
		moduleName: "Client Application",
		icon: "fas fa-th",
		class: "",
		groupTitle: false,
		submenu: [],
		type: "1",
	},
	{
		path: "",
		title: "Manage",
		moduleName: "user management",
		icon: "fas fa-users-cog",
		class: "menu-toggle",
		groupTitle: false,
		type: "1",
		submenu: [
			{
				path: "/client/people",
				title: "Users",
				moduleName: "people",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/client/custom-fields",
				title: "Custom Fields",
				moduleName: "people",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/client/batch-jobs",
				title: "User import Status",
				moduleName: "people",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
		],
	},
	{
		path: "",
		title: "Security",
		moduleName: "MFA Module",
		icon: "fas fa-user-lock",
		class: "menu-toggle",
		groupTitle: false,
		type: "1",

		submenu: [
			{
				path: "/client/mfa",
				title: "MFA",
				moduleName: "",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/client/idp",
				title: "Identity Providers",
				moduleName: "",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/client/auth-methods",
				title: "Authentication Methods",
				moduleName: "",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
		],
	},
	{
		path: "",
		title: "Configurations",
		moduleName: "Configurations",
		icon: "fas fa-user-cog",
		class: "menu-toggle",
		groupTitle: false,
		type: "1",

		submenu: [
			{
				path: "/client/alerts",
				title: "Alerts",
				moduleName: "",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			}

		],
	},
  {
    path:"",
    title:"Reports",
    moduleName:"ReportsModule",
    icon:"far fa-file",
    class:"menu-toggle",
    groupTitle:false,
    type:"1",
    submenu:[
      {
				path: "/client/people",
        queryParams:{'hideActions':true},
				title: "User Status",
				moduleName: "UserModule",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
      {
				path: "/reports/user-logs",
				title: "User Logs",
				moduleName: "ReportsModule",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/reports/deleted-users",
				title: "Deleted users",
				moduleName: "ReportsModule",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
    ]
  },
	{
		path: "",
		title: "Templates",
		moduleName: "Templates",
		icon: "far fa-newspaper",
		class: "menu-toggle",
		groupTitle: false,
		type: "1",

		submenu: [
			{
				path: "/client/email-templates",
				title: "Email Template",
				moduleName: "Template",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
			{
				path: "/client/providers",
				title: "Email Providers",
				moduleName: "Template",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			},
		],
	},


	{
		path: "",
		title: "Developer Zone",
		moduleName: "Api Documentation",
		icon: "fas fa-laptop-code",
		class: "menu-toggle",
		groupTitle: false,
		type: "1",
		submenu: [
			{
				path: "/client/api-documentation",
				title: "Api documentation",
				moduleName: "Template",
				icon: "",
				class: "ml-menu",
				groupTitle: false,
				submenu: [],
				type: "1",
			}

		],
	},
]
